<template>
  <router-link
    v-if="isVisible"
    :to="{ name: item.routeName }"
    custom
    v-slot="{ navigate, href }"
  >
    <a
      :href="href"
      class="admin-nav-item"
      :class="[{ 'admin-nav-item--active': isActive, 'admin-nav-item--collapsed': collapsed }]"
      :aria-current="isActive ? 'page' : undefined"
      :title="collapsed ? item.label : undefined"
      @click="select(navigate, $event)"
    >
      <i class="admin-nav-item__icon fa" :class="item.icon" aria-hidden="true"></i>
      <span v-if="!collapsed" class="admin-nav-item__label">{{ item.label }}</span>
      <span v-if="!collapsed && badgeCount" class="admin-nav-item__badge">{{ badgeCount }}</span>
    </a>
  </router-link>
</template>

<script>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { hasAdminAccess, useAdminSession } from "@/admin/adminSession";

export default {
  name: "AdminNavItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["select"],
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const { stats } = useAdminSession();

    const routeRecord = computed(() =>
      router.getRoutes().find((entry) => entry.name === props.item.routeName)
    );

    const isVisible = computed(() => {
      const access = routeRecord.value?.meta?.adminAccess;
      return hasAdminAccess(access, stats.value?.permissions || {});
    });

    const isActive = computed(() => route.meta.nav === props.item.key);

    const badgeCount = computed(() => {
      if (!props.item.badge) return null;
      return stats.value?.[props.item.badge] || null;
    });

    function select(navigate, event) {
      navigate(event);
      emit("select");
    }

    return { isVisible, isActive, badgeCount, select };
  },
};
</script>
